export const BUTTON_SIZE = {
    small: "text-sm",
    base: "text-lg",
} as const;

type ObjectValues<T> = T[keyof T];
export type ButtonSizeType = ObjectValues<typeof BUTTON_SIZE>

